import React from 'react';
import ReactDOM from 'react-dom/client';

import CmnWrap from './comp/common/CmnWrap';
import LiveReserve from './comp/lesson/live/reserve/LiveReserve';
import PracticeReserve from './comp/practice/reserve/PracticeReserve';
import SaleList from './comp/sale/list/SaleList';
import InquiryHelpSearch from './comp/inquiry/help/search/InquiryHelpSearch';


// ライブレッスン予約
const lessonReserveContainer = document.getElementById('comp_lesson_reserve');
if (lessonReserveContainer) {
  const compLessonReserve = ReactDOM.createRoot(lessonReserveContainer);
  compLessonReserve.render(
    <React.StrictMode>
      <CmnWrap>
        <LiveReserve />
      </CmnWrap>
    </React.StrictMode>
  );
}


// プラクティス予約
const practiceReserveContainer = document.getElementById('comp_practice_reserve');
if (practiceReserveContainer) {
  const compPracticeReserve = ReactDOM.createRoot(practiceReserveContainer);
  compPracticeReserve.render(
    <React.StrictMode>
      <CmnWrap>
        <PracticeReserve />
      </CmnWrap>
    </React.StrictMode>
  );
}


// 動画レッスン
const saleListContainer = document.getElementById('comp_sale_list');
if (saleListContainer) {
  const compSaleList = ReactDOM.createRoot(saleListContainer);
  compSaleList.render(
    <React.StrictMode>
      <CmnWrap>
        <SaleList />
      </CmnWrap>
    </React.StrictMode>
  );
}


// よくある質問:検索
const inquiryHelpSearchContainer = document.getElementById('comp_inquiry_help_search');
if (inquiryHelpSearchContainer) {
  const compInquiryHelpSearch = ReactDOM.createRoot(inquiryHelpSearchContainer);
  compInquiryHelpSearch.render(
    <React.StrictMode>
      <CmnWrap>
        <InquiryHelpSearch />
      </CmnWrap>
    </React.StrictMode>
  );
}